export default [{
  path: 'dashboard',
  name: 'dashboardRoot',
  component: () => import(/* webpackChunkName: "dashboard" */ './Dashboard.vue'),
}, {
  path: 'servers',
  name: 'allServers',
  component: () => import(/* webpackChunkName: "dashboard" */ './AllServers.vue'),
}];
